import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import useAcademy from "../../../../hooks/useAcademy";

export default function ModuleModal({
  setOpenModule,
  trainingID,
  onTrigger,
  module,
}) {
  const { saveModule } = useAcademy();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    training: trainingID || "",
  });

  const [errors, setErrors] = useState({
    title: "",
    description: "",
  });

  // Pre-fill when editing
  useEffect(() => {
    if (module) {
      setFormData({
        title: module.title || "",
        description: module.description || "",
        training: trainingID || "",
      });
    }
  }, [module, trainingID]);

  const validate = () => {
    let valid = true;
    const newErrors = { title: "", description: "" };

    if (!formData.title.trim()) {
      newErrors.title = "Title is required";
      valid = false;
    }
    if (!formData.description.trim()) {
      newErrors.description = "Description is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleConfirm = async () => {
    if (!validate()) return;
    setLoading(true);

    try {
      if (module) {
        await saveModule(setLoading, formData, module._id, "PATCH");
      } else {
        await saveModule(setLoading, formData);
      }
      void onTrigger();
      setOpenModule(false);
    } catch (err) {
      console.error("Error saving module:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div
        className="bg-white w-full max-w-md relative rounded-md shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-center bg-blue-600 text-white px-6 py-4">
          <h2 className="text-lg text-white font-semibold">
            {module ? "Update Module" : "Add new Module"}
          </h2>
          <button
            onClick={() => setOpenModule(false)}
            className="text-white hover:text-gray-200"
          >
            <CloseIcon />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div className="flex flex-col">
            <label className="text-sm text-gray-600">Name</label>
            <input
              type="text"
              placeholder="eg. Starter"
              value={formData.title}
              onChange={(e) =>
                setFormData({ ...formData, title: e.target.value })
              }
              className={`w-full border ${
                errors.title ? "border-red-500" : "border-gray-300"
              } rounded-md px-4 py-2 focus:outline-none`}
            />
            {errors.title && (
              <span className="text-xs text-red-500">{errors.title}</span>
            )}
          </div>

          {/* Description */}
          <div className="flex flex-col">
            <label className="text-sm text-gray-600">Short Description</label>
            <textarea
              rows={4}
              placeholder="eg. Starter"
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
              className={`w-full border ${
                errors.description ? "border-red-500" : "border-gray-300"
              } rounded-md px-4 py-2 focus:outline-none`}
            ></textarea>
            {errors.description && (
              <span className="text-xs text-red-500">{errors.description}</span>
            )}
          </div>

          {/* Actions */}
          <div className="grid grid-cols-4 gap-4 w-full">
            <button
              onClick={() => setOpenModule(false)}
              className="bg-white col-span-1 font-medium text-black px-4 py-2 rounded-md"
            >
              Close
            </button>
            <button
              onClick={handleConfirm}
              disabled={loading}
              className="bg-blue-500 col-span-3 font-medium text-white px-4 py-2 rounded-md hover:bg-blue-600"
            >
              {loading
                ? module
                  ? "Updating..."
                  : "Creating..."
                : module
                ? "Update"
                : "Create"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
